import { useBreadcrumb } from 'react-instantsearch';
import CategoryBreadcrumb from '../product-search/shared/CategoryBreadcrumb';

function CustomBreadcrumb({ ...props }) {
  const { items, refine, createURL } = useBreadcrumb(props);

  return (
    <CategoryBreadcrumb
      items={items}
      onRefine={refine}
      createURL={createURL}
    />
  );
}

export default CustomBreadcrumb;
